/**
 * maxTrainees 기반으로 수업 형태(ClassType)를 결정한다.
 *
 * - maxTrainees === 1 → "PRIVATE_REGULAR" (1:1 개인 수업)
 * - maxTrainees >= 2  → "GROUP_REGULAR"   (2:1 이상 그룹 수업)
 * - maxTrainees === 0 → 에러 (비정상 데이터)
 *
 * Studiomate type 필드("P"/"G")는 무시한다 (maxTrainees만 사용).
 *
 * @param maxTrainees 수업 최대 참여자 수
 * @returns ClassType
 * @throws Error maxTrainees가 0 이하인 경우
 */
export function detectClassType(maxTrainees) {
    if (maxTrainees <= 0) {
        throw new Error(`detectClassType: maxTrainees가 ${maxTrainees}입니다. 유효한 값(1 이상)이어야 합니다. 데이터를 확인해주세요.`);
    }
    return maxTrainees === 1 ? "PRIVATE_REGULAR" : "GROUP_REGULAR";
}
/**
 * 수업 이름의 첫 4글자가 "(OT)"인지 판별한다 (대소문자 무시).
 *
 * - "(OT) 체험 수업" → true
 * - "(ot) 소문자"    → true
 * - "정규 수업"      → false
 * - " (OT) 앞공백"   → false (startsWith이므로)
 *
 * @param title 수업 이름
 * @returns OT 여부
 */
export function detectIsOt(title) {
    if (title.length < 4)
        return false;
    return title.slice(0, 4).toUpperCase() === "(OT)";
}
/**
 * 상담 이름이 "(체험단)"으로 시작하는지 판별한다.
 *
 * - "(체험단) 한정현님 5회차" → true
 * - "(상담) 김지수"          → false
 * - "(OT) 오세미"            → false
 *
 * @param counselName 상담 이름
 * @returns 체험단 여부
 */
export function detectTrialCounsel(counselName) {
    return counselName.startsWith("(체험단)");
}
//# sourceMappingURL=detect-class-info.js.map